module.exports = __webpack_public_path__ + "static/media/Benifits6.292a7237.png";